export var contratosSincronizando = function contratosSincronizando(state) {
  return state.contratosSincronizando;
};
export var tokenContratoSincronizando = function tokenContratoSincronizando(state) {
  return function (contratoId) {
    return state.contratosSincronizando[String(contratoId)] || null;
  };
};
export var contratoEstaSincronizando = function contratoEstaSincronizando(state) {
  return function (contratoId) {
    return Boolean(state.contratosSincronizando[String(contratoId)]);
  };
};